import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form'

import {SettingsNav} from '../../components/SettingsNav'

export class SettingsGeneral extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      invoicePeriod: '',
      cutOffDays: '',
      cutOffTime: '',
      enableAutoInvoice: '',
      enableOrderReminders: '',
      defaultDeliveryDays: [],
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      integration: {},
      paymentTermsOption: '',
      paymentTermsValue: '',
      minOrderValue: '',
      holidays: [],
      announcement: '',
      orderCutOffExcludeWeekends: '',
      catalogues: [],
      defaultCatalogue: null,
      priceLists: [],
      defaultPriceList: null,
      reminderTime1: '',
      reminderTime2: '',
      invoiceWeeklySummaryEnabled: false,
      enableNotifications: false
  }

  componentWillMount() {
      this.fetchSupplierData();
      this.fetchCatalogues();
      this.fetchPriceLists();
  }

  handleChange (evt) {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    this.setState({ [evt.target.name]: value });
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          console.log(data);
          var settings = JSON.parse(data[0].settings)
          this.setState({
            invoicePeriod: settings.invoicePeriod,
            cutOffDays: settings.cutOffDays,
            cutOffTime: settings.cutOffTime,
            enableAutoInvoice: settings.enableAutoInvoice,
            enableOrderReminders: settings.enableOrderReminders,
            defaultDeliveryDays: settings.defaultDeliveryDays,
            integration: settings.integration,
            paymentTermsOption: settings.paymentTerms.option,
            paymentTermsValue: settings.paymentTerms.value,
            minOrderValue: settings.minOrderValue,
            holidays: settings.holidays,
            announcement: settings.announcement,
            orderCutOffExcludeWeekends: settings.orderCutOffExcludeWeekends,
            defaultCatalogue: settings.defaultCatalogue,
            defaultPriceList: settings.defaultPriceList,
            reminderTime1: settings.reminderTime1,
            reminderTime2: settings.reminderTime2,
            invoiceWeeklySummaryEnabled: settings.invoiceWeeklySummaryEnabled,
            enableNotifications: settings.enableNotifications
          });
          this.dayCheckboxWrapper();
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async () => {
    let newDeliveryDays = this.updateDeliveryDays();
    let newSettings = {}
    newSettings.invoicePeriod = this.state.invoicePeriod
    newSettings.cutOffDays = this.state.cutOffDays
    newSettings.cutOffTime = this.state.cutOffTime
    newSettings.enableAutoInvoice = this.state.enableAutoInvoice
    newSettings.enableOrderReminders = this.state.enableOrderReminders
    newSettings.defaultDeliveryDays = newDeliveryDays
    newSettings.integration = this.state.integration
    newSettings.paymentTerms = {option: this.state.paymentTermsOption, value: this.state.paymentTermsValue}
    newSettings.minOrderValue = this.state.minOrderValue
    newSettings.holidays = this.state.holidays
    newSettings.announcement = this.state.announcement
    newSettings.orderCutOffExcludeWeekends = this.state.orderCutOffExcludeWeekends
    newSettings.defaultCatalogue = this.state.defaultCatalogue == 'None' ? null : this.state.defaultCatalogue
    newSettings.defaultPriceList = this.state.defaultPriceList == 'None' ? null : this.state.defaultPriceList
    newSettings.reminderTime1 = this.state.reminderTime1
    newSettings.reminderTime2 = this.state.reminderTime2
    newSettings.invoiceWeeklySummaryEnabled = this.state.invoiceWeeklySummaryEnabled
    newSettings.enableNotifications = this.state.enableNotifications
    let requestParams = {
      'settings': newSettings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
          console.log(data);
          toast.success("Settings Saved!");
        })
        .catch (err => {
          console.log(err); 
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  updateDeliveryDays() {
    let arr = [];
    if(this.state.monday) { arr.push("Monday") }
    if(this.state.tuesday) { arr.push("Tuesday") }
    if(this.state.wednesday) { arr.push("Wednesday") }
    if(this.state.thursday) { arr.push("Thursday") }
    if(this.state.friday) { arr.push("Friday") }
    if(this.state.saturday) { arr.push("Saturday") }
    if(this.state.sunday) { arr.push("Sunday") }
    return arr;
  }

  dayCheckboxWrapper() {
    let arr = this.state.defaultDeliveryDays
    if(arr.includes("Monday")) {this.setState({ monday: true }) }
    if(arr.includes("Tuesday")) {this.setState({ tuesday: true }) }
    if(arr.includes("Wednesday")) {this.setState({ wednesday: true }) }
    if(arr.includes("Thursday")) {this.setState({ thursday: true }) }
    if(arr.includes("Friday")) {this.setState({ friday: true }) }
    if(arr.includes("Saturday")) {this.setState({ saturday: true }) }
    if(arr.includes("Sunday")) {this.setState({ sunday: true }) }
  }

  fetchPriceLists = async () => {
    axios.get('/pricelists')
        .then(data => {
            console.log(data);
            data.unshift({priceListID: null, priceListName: 'None'})
            this.setState({
              priceLists: data
            });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch price lists')
        })
  }

  fetchCatalogues = async () => {
    axios.get('/catalogues')
        .then(data => {
            console.log(data);
            data.unshift({catalogueID: null, catalogueName: 'None'})
            this.setState({
              catalogues: data
            });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch catalogues')
        })
  }

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Settings</h1>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <SettingsNav/>
                </div>
                <div className="col-md-10 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      Supplier Settings
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>Default Payment Terms:</label>
                        <div className="input-group">
                          <select className="custom-select" name="paymentTermsOption" value={this.state.paymentTermsOption} onChange={this.handleChange} >
                            <option value="CashOnDelivery">Cash on Delivery</option>
                            <option value="PrePaid">Prepaid</option>
                            <option value="InAGivenNumberOfDays">In a given number of days</option>
                            <option value="OnADayOfTheMonth">On a day of the month</option>
                            <option value="NumberOfDaysAfterEOM">Number of days after EOM</option>
                            <option value="DayOfMonthAfterEOM">Day of month after EOM</option>
                          </select>
                          {this.state.paymentTermsOption === 'InAGivenNumberOfDays' || this.state.paymentTermsOption === 'NumberOfDaysAfterEOM' ? 
                          <>
                            <input type="number" className="form-control" value={this.state.paymentTermsValue} onChange={this.handleChange} name="paymentTermsValue" />
                            <div className="input-group-append">
                              <label className="input-group-text">Days</label>
                            </div> 
                          </>: null}
                          {this.state.paymentTermsOption === 'OnADayOfTheMonth' ? 
                            <input type="date" className="form-control" value={this.state.paymentTermsValue} onChange={this.handleChange} name="paymentTermsValue" />
                          : null}
                        </div>
                        <small className="form-text text-muted">
                          When the payment is due. This value will be overridden if set individually at the customer level.
                        </small>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-heading-label">Auto Invoicing:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          id={'enableAutoInvoice'}
                          name={'enableAutoInvoice'}
                          label={'Enabled'}
                          checked={this.state.enableAutoInvoice}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          Automatically send out invoices via email as per the value below.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Invoice Period (Days):</label>
                        <input type="number" className="form-control" value={this.state.invoicePeriod} onChange={this.handleChange} name="invoicePeriod" min="0" />
                        <small className="form-text text-muted">
                          When the system should send out the invoice. Set this value to 0 to have the invoice be sent out immediately after an order is placed.
                        </small>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-heading-label">Weekly Invoice Summary:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          id={'invoiceWeeklySummaryEnabled'}
                          name={'invoiceWeeklySummaryEnabled'}
                          label={'Enabled'}
                          checked={this.state.invoiceWeeklySummaryEnabled}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          Automatically send out a weekly invoice summary via email at 5pm on Friday.
                        </small>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-heading-label">Notifications:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          id={'enableNotifications'}
                          name={'enableNotifications'}
                          label={'Enabled'}
                          checked={this.state.enableNotifications}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          Recieve notifications for new orders placed by customers.
                        </small>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-heading-label">Auto Email/SMS Reminders:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          id={'enableOrderReminders'}
                          name={'enableOrderReminders'}
                          label={'Enabled'}
                          checked={this.state.enableOrderReminders}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          Send out automatic order reminders to your customers via email and sms.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Reminder Time 1:</label>
                        <input type="number" className="form-control" value={this.state.reminderTime1} onChange={this.handleChange} name="reminderTime1" min="0" />
                        <small className="form-text text-muted">
                          X hours before the cut off time. E.g. if cut off time below is 6pm, then set this value to 2 to send out a reminder at 4pm.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Reminder Time 2:</label>
                        <input type="number" className="form-control" value={this.state.reminderTime2} onChange={this.handleChange} name="reminderTime2" min="0" />
                      </div>
                      <div className="form-group">
                        <label>Order cut off days:</label>
                        <input type="number" className="form-control" value={this.state.cutOffDays} onChange={this.handleChange} name="cutOffDays" min="0" />
                        <small className="form-text text-muted">
                          The number of days before the cut off time to place an order is reached. E.g. 2 days. Customer places order on Monday for a Wednesday delivery.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Order cut off time (24hr):</label>
                        <input type="number" className="form-control" value={this.state.cutOffTime} onChange={this.handleChange} name="cutOffTime" min="0" max="23" />
                        <small className="form-text text-muted">
                          Used in conjunction with the above cut off days. E.g. before 2:00pm on Monday.
                        </small>
                      </div>
                      <div className="form-group">
                        <label className="checkbox-heading-label">Order cut off:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          id={'orderCutOffExcludeWeekends'}
                          name={'orderCutOffExcludeWeekends'}
                          label={'Exclude Weekends'}
                          checked={this.state.orderCutOffExcludeWeekends}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          E.g. 2 day cut off for Monday would result in Thursday.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Minimum Order Value:</label>
                        <input type="number" className="form-control" value={this.state.minOrderValue} onChange={this.handleChange} name="minOrderValue" min="0" />
                        <small className="form-text text-muted">
                          Set this to 0 to accept any order value.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Default Delivery Days:</label>
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'monday'}
                          id={'monday'}
                          label={'Monday'}
                          checked={this.state.monday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'tuesday'}
                          id={'tuesday'}
                          label={'Tuesday'}
                          checked={this.state.tuesday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'wednesday'}
                          id={'wednesday'}
                          label={'Wednesday'}
                          checked={this.state.wednesday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'thursday'}
                          id={'thursday'}
                          label={'Thursday'}
                          checked={this.state.thursday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'friday'}
                          id={'friday'}
                          label={'Friday'}
                          checked={this.state.friday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'saturday'}
                          id={'saturday'}
                          label={'Saturday'}
                          checked={this.state.saturday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <Form.Check 
                          custom
                          type={'checkbox'}
                          name={'sunday'}
                          id={'sunday'}
                          label={'Sunday'}
                          checked={this.state.sunday}
                          onChange={(e) => {this.handleChange(e)}}
                        />
                        <small className="form-text text-muted">
                          These delivery days will be set automatically when a customer is added/signs up. You can adjust this on an indiviudal customer level once they have signed up.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Default Catalogue:</label>
                        <select className="custom-select" name="defaultCatalogue" value={this.state.defaultCatalogue} onChange={this.handleChange} >
                          {this.state.catalogues.map((data, i) =>
                            <option key={i} value={data.catalogueID}>{data.catalogueName}</option>
                          )}
                        </select>
                        <small className="form-text text-muted">
                          This catalogue will be applied to all new users when they sign up. This value can be configured on a per customer level once they have created an account.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Default Price List:</label>
                        <select className="custom-select" name="defaultPriceList" value={this.state.defaultPriceList} onChange={this.handleChange} >
                          {this.state.priceLists.map((data, i) =>
                            <option key={i} value={data.priceListID}>{data.priceListName}</option>
                          )}
                        </select>
                        <small className="form-text text-muted">
                          This price list will be applied to all new users when they sign up. This value can be configured on a per customer level once they have created an account.
                        </small>
                      </div>
                      <div className="form-group">
                        <label>Announcement:</label>
                        <input type="text" className="form-control" value={this.state.announcement} onChange={this.handleChange} name="announcement" />
                        <small className="form-text text-muted">
                          This message will be displayed in a banner at the top of your customers ordering page.
                        </small>
                      </div>
                      <button type="button" onClick={this.updateSettings.bind(this)} className="btn btn-success btn-block">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
}
